// extracted by css-extract-rspack-plugin
export default {"body1":"Body1_body1__F9JdN","body1-text-link":"Body1_body1-text-link__6kxuP"};